export default __webpack_public_path__ + "static/receiptmakerly-login-34c0bc1844ab3e2e58f23d3d6fe4a929.png";